// @flow
/**
 * User: Mike Chung
 * Date: 21/1/2018
 * Time: 12:26 AM
 */
import React from 'react';
import {Button} from "reactstrap";
import type {Caller} from "../QueryPage";

export type EBadgeActionButtonOwnProps = {
    registrationCode: string,
    disabled: boolean,
    unlockCount: number,
    label: string,
    loadingComponent?: React.Component<any> | string | () => React.Component<any>,
    criteria?: any
};

export type EBadgeActionButtonStateProps = {
    isLoading: boolean,
    caller: Caller,
    roleIds: Array<string>
}

export type EBadgeActionButtonDispatchProps = {

    onClick: (registrationCode: string, unlockCount: number, caller: Caller, roleIds: Array<string>) => any
}

export type EBadgeActionButtonProps = EBadgeActionButtonOwnProps & EBadgeActionButtonStateProps & EBadgeActionButtonDispatchProps;

export default function EBadgeActionButton(props: EBadgeActionButtonProps) {

    const {onClick, unlockCount, isLoading, loadingComponent, label, disabled, registrationCode, caller, roleIds, ...rest} = props;
    return (<Button disabled={isLoading || disabled} onClick={() => (onClick(registrationCode, unlockCount, caller, roleIds))} {...rest}>{isLoading && loadingComponent ? loadingComponent : label}</Button>)
};




// WEBPACK FOOTER //
// ./src/components/ebadge/EBadgeActionButton.js